export { default } from './KnowBefore.data';
